import type { BreakpointNames } from '@workramp/ui';

export const isMobile = (breakpoint: BreakpointNames) => breakpoint === 'xs' || breakpoint === 'sm';
